import React from 'react';
const bonuses = [{
  title: 'Planificación Express 12 Meses',
  desc: 'El año organizado por mes en 10 minutos',
  price: '$8.000'
}, {
  title: '30 Clases Salvavidas',
  desc: 'Abrís una ficha y la clase funciona',
  price: '$10.000'
}, {
  title: 'Banco de Evaluaciones',
  desc: '12 rúbricas + 20 instrumentos de evaluación rápidos',
  price: '$7.000'
}, {
  title: 'Guía de Pronunciación',
  desc: 'Para sonar natural aunque no seas nativo',
  price: '$6.000'
}, {
  title: 'Kit Días Especiales',
  desc: 'Halloween, Christmas, Easter + efemérides argentinas',
  price: '$9.000'
}, {
  title: 'Vocabulario Visual por Grado',
  desc: '120 flashcards digitales organizadas por nivel',
  price: '$5.000'
}];
export function BonusSection() {
  return <section className="w-full bg-black py-12 sm:py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            + <span className="text-[#FF6B00]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-6">
            Incluidos en todas las opciones — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-8" data-id="element-7">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#1a0d00] border border-[#FF6B00]/60 rounded-xl p-4 sm:p-5 flex flex-col" data-id="element-8">
              <div className="flex items-center gap-2 mb-2" data-id="element-9">
                <span className="text-[#FF6B00] font-black text-2xl leading-none" data-id="element-10">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-gray-400 text-[10px] font-bold uppercase tracking-widest" data-id="element-11">
                  🎁 BONO
                </span>
              </div>
              <h3 className="text-white font-black text-base mb-1" data-id="element-12">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-3 leading-snug" data-id="element-13">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-2" data-id="element-14">
                <span className="text-gray-500 line-through text-xs" data-id="element-15">
                  {bonus.price}
                </span>
                <span className="bg-[#FF6B00] text-black font-black text-xs px-2.5 py-0.5 rounded-full" data-id="element-16">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="border border-[#FF6B00]/40 rounded-xl p-5 text-center bg-[#0d0800]" data-id="element-17">
          <p className="text-green-400 text-xl sm:text-2xl font-black" data-id="element-18">
            🎁 $45.000 en bonos — GRATIS
          </p>
          <p className="text-gray-400 text-sm mt-1" data-id="element-19">
            Incluidos en las 3 opciones. Siempre.
          </p>
        </div>
      </div>
    </section>;
}